export default function (price: number): string {
  if (typeof price === 'undefined' || price === null) {
    return ''
  }

  if (typeof price === 'number') {
    return `$${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }
  else {
    return `$${price}`
  }
}
